"use client";
import { create } from "zustand";

// Define types
type TABS = "login" | "register";

interface AddressItem {
  address_id: string;
  firstname: string;
  lastname: string;
  company: string;
  address_1: string;
  address_2: string;
  postcode: string;
  city: string;
  zone_id: string;
  zone: string;
  zone_code: string;
  country_id: string;
  country: string;
  iso_code_2: string;
  iso_code_3: string;
  address_format: string;
  custom_field: null;
  default: boolean;
  replace_email?: string;
  confirm_email?: string;
  agree?: boolean;
}

interface CheckoutStore {
  activeStep: number | null;
  setActiveStep: (step: number | null) => void;
  steps: any[];
  setSteps: (steps: any[] | ((prevSteps: any[]) => any[])) => void;
  newAddressOpen: boolean;
  setNewAddressOpen: (open: boolean) => void;
  guestLoginLoading: boolean;
  setGuestLoginLoading: (open: boolean) => void;
  editingAddress: AddressItem | null;
  setEditingAddress: (address: AddressItem | null) => void;
  selectedAddressId: string;
  setSelectedAddressId: (id: string) => void;
  checkoutOtp: boolean;
  setCheckoutOtp: (otp: boolean) => void;
  checkoutActiveTab: TABS;
  setCheckoutActiveTab: (tab: TABS) => void;
  total: number;
  currency: string;
  setTotal: (total: number) => void;
  setCurrency: (currency: string) => void;
  amlChecked: boolean;
  setAmlChecked: (checked: boolean) => void;
}

// Create the Zustand store
export const useCheckoutStore = create<CheckoutStore>((set) => ({
  activeStep: null,
  total: 0,
  guestLoginLoading: false,
  setGuestLoginLoading: (loading: boolean) => set({ guestLoginLoading: loading }),
  currency: "CHF",
  setTotal: (total: number) => set({ total }),
  setCurrency: (currency: string) => set({ currency }),
  setActiveStep: (step) => {
    set({ activeStep: step });
    // Scroll to top when step changes
    window.scrollTo({ top: 0, behavior: "smooth" });
  },
  steps: [
    { title: "Account", step: 1, checked: false },
    { title: "Address", step: 2, checked: false },
    { title: "Payment", step: 3, checked: false },
  ],
  setSteps: (stepsOrUpdater) =>
    set((state) => ({
      steps: typeof stepsOrUpdater === "function" ? stepsOrUpdater(state.steps) : stepsOrUpdater,
    })),
  newAddressOpen: false,
  setNewAddressOpen: (open) => set({ newAddressOpen: open }),
  editingAddress: null,
  setEditingAddress: (address) => set({ editingAddress: address }),
  selectedAddressId: "0",
  setSelectedAddressId: (id) => set({ selectedAddressId: id }),
  checkoutOtp: false,
  setCheckoutOtp: (otp) => set({ checkoutOtp: otp }),
  checkoutActiveTab: "login",
  setCheckoutActiveTab: (tab) => set({ checkoutActiveTab: tab }),
  amlChecked: false,
  setAmlChecked: (checked) => set({ amlChecked: checked }),
}));
